import { useState, useEffect } from "react";
import { THEME_SYSTEM, resolveAppliedTheme } from "../components/utils";

/**
 * Resolves the concrete theme class applied to the document (e.g. for system preference).
 *
 * @param {string} themePreference - Stored selection: a theme name or {@link THEME_SYSTEM}.
 * @returns {string} Concrete theme name (`light`, `dark`, `midnight`, …).
 */
export function useEffectiveTheme(themePreference) {
  const [effective, setEffective] = useState(() =>
    resolveAppliedTheme(themePreference)
  );

  useEffect(() => {
    setEffective(resolveAppliedTheme(themePreference));

    if (themePreference !== THEME_SYSTEM) {
      return undefined;
    }

    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = () => {
      setEffective(resolveAppliedTheme(THEME_SYSTEM));
    };
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [themePreference]);

  return effective;
}
